<form autocomplete="off" [formGroup]="adjustmentForm" (submit)="onSubmit()" id="adjustmentForm">
  <app-adjustement-modal-template title="Select Adjustment">
    <div header>
      <!--app-check-box-group [values]="adjustmentTypes" labelName="displayText" formControlName="adjustmentTypes"></app-check-box-group-->

      <ng-container *ngFor="let v of adjustmentTypes">
        <div class="flex-row">
          <p-checkbox name="adjTypes" [value]="v" [label]="v['displayText']" [formControl]="adjustmentForm.controls['adjustmentTypes']"></p-checkbox>
          <app-radio-button
            [readonly]="isReadOnly(adjustmentForm.get('adjustmentTypes').value, v.lookupId)"
            [name]="v.lookupId"
            [values]="v.lookupId !== invetoryAdjustmentId ? interestRateVariants_Local : interestRateVariants_NoHoldingPeriod"
            labelName="displayText"
            formControlName="interestRateVariants_{{ v.lookupId }}"
          ></app-radio-button>
        </div>
      </ng-container>
    </div>
    <div body>
      <span class="help-block chk-interest" *ngIf="!interestRateDetailsProvided">
        Interest rate and source are required before an adjustment can be calculated.
      </span>
    </div>
    <div footer>
      <button type="button" class="btn btn-default m-2" (click)="close()">Cancel</button>
      <button type="submit" class="btn btn-primary m-2" [disabled]="readOnly || !adjustmentForm.valid || !interestRateDetailsProvided">
        Calculate
      </button>
    </div>
  </app-adjustement-modal-template>
</form>
